import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListZnsEventBranchMap = createAsyncThunk(
    "znsEventBranchMap/getListZnsEventBranchMap",
    async ({ currentPage, pageSize, branchId, eventId}, { rejectWithValue }) => {
        try {
            let apiUrl = `/api/v1/serviceconnect/zns-branchs?has_paginate&size=${pageSize}&page=${currentPage}`;
            if (branchId) { // Nếu chỉ có branchId
              apiUrl += `&mcoupon_branch_id=${branchId}`;
            }

            if (eventId) { // Nếu chỉ có eventId
              apiUrl += `&zns_event_id=${eventId}`;
            }

            const response = await http.get(apiUrl);
            return response.data;
        } catch (error) {
            return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);

export const createZnsEventBranchMap = createAsyncThunk(
  "znsEventBranchMap/createZnsEventBranchMap",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/zns-branchs`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateZnsEventBranchMap = createAsyncThunk(
  "znsEventBranchMap/updateZnsEventBranchMap", // Đổi tên hành động cho phù hợp
  async ({ id, data }, { rejectWithValue }) => { // Lấy đối tượng có `id` và `data`
    try {
      const response = await http.put(`/api/v1/serviceconnect/zns-branchs/${id}`, data); // Gọi API PUT
      return response.data; // Trả về kết quả thành công
    } catch (error) {
      return rejectWithValue(error.response.data); // Trả về lỗi nếu có
    }
  }
);

// Xem mẫu tin ZNS từ Zalo (preview template)
export const getZnsTemplate = (templateId) =>
  http.get(`/api/v1/serviceconnect/zns-templates?template_id=${templateId}`);

// Danh sách biến hệ thống (alias) theo sự kiện
export const getAvailableAliases = (eventId) =>
  http.get(
    `/api/v1/serviceconnect/zns-events/available-variable-aliases?event_id=${eventId}`
  );

export const deleteZnsEventBranchMap = createAsyncThunk(
  "znsEventBranchMap/deleteZnsEventBranchMap",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/api/v1/serviceconnect/zns-branchs/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
